import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row'
    },
    icon: {
        margin: 16,
    },
    textContaner: {
        flex: 1,
        marginRight: 16
    },
    title: theme => ({
        marginTop: 16,
        lineHeight: 24,
        color: theme.colors.textColorThree
    }),
    desc: theme => ({
        marginLeft: 16,
        lineHeight: 20,
        color: theme.colors.textColorTwo
    }),
    bottomText: theme => ({
        marginTop: 16
    })
})

export default styles
